export default __webpack_public_path__ + "static/media/obs_step6.5bf6ebc9.png";